import {
  DateRangeFilterValue,
  FilterOptionItem,
  FilterPickerType,
  FilterSelectedValue,
} from "../../types";
import { format } from "date-fns";

export const isDateRangeValue = (
  value: FilterSelectedValue | undefined,
): value is DateRangeFilterValue =>
  Boolean(value) &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  ("startDate" in value || "endDate" in value);

export const getDefaultSelectedValue = (
  pickerType: FilterPickerType,
): FilterSelectedValue =>
  pickerType === FilterPickerType.DATE_RANGE
    ? { startDate: null, endDate: null }
    : [];

const formatFilterDate = (dateValue: string | null) => {
  if (!dateValue) return null;

  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return null;

  return format(date, "dd/MM/yyyy");
};

export const getDateRangeLabel = (
  filterName: string,
  value: DateRangeFilterValue,
) => {
  const startDate = formatFilterDate(value.startDate);
  const endDate = formatFilterDate(value.endDate);

  if (startDate && endDate) {
    if (startDate === endDate) {
      return `${filterName}: ${startDate}`;
    }
    return `${filterName}: ${startDate} - ${endDate}`;
  }

  if (startDate) {
    return `${filterName}: ${startDate}`;
  }

  if (endDate) {
    return `${filterName}: ${endDate}`;
  }

  return filterName;
};

export const isDateRangeApplied = (value: DateRangeFilterValue) =>
  Boolean(value.startDate?.trim() || value.endDate?.trim());

export const getSelectedOptionLabels = (
  options: FilterOptionItem[],
  selectedIds: string[],
): string =>
  options
    .filter((option) => selectedIds.includes(option.id))
    .map((option) => option.label)
    .join(", ");
